import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { clientOnly } from 'utils/react';
import WebsiteTable from './WebsiteTable';
import classes from './Dashboard.scss';

const LaunchStats = ({ sitesPerMonth, newSites }) => {
  // Chart.js requires the window to be present to work properly, so we can't import this
  // up above or bad server-side rendering things happen
  const BarChart = require('react-chartjs-2').Bar; // eslint-disable-line global-require

  // Only pick the last two years
  const datasets = Object.keys(sitesPerMonth)
    .sort()
    .slice(Object.keys(sitesPerMonth).length - 2)
    .map((year, index) => ({
      label: year,
      data: sitesPerMonth[year],
      backgroundColor: index === 0 ? '#2ba7df' : '#8fc83c',
    }));

  return (
    <Container fluid className={classes.padTop}>
      <Row>
        <Col md={6}>
          <BarChart
            data={{
              labels: [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December',
              ],
              datasets,
            }}
            options={{
              scales: {
                yAxes: [{
                  ticks: {
                    suggestedMin: 0,
                  },
                }],
              },
            }}
          />
        </Col>
        <Col md={6}>
          <WebsiteTable title="New Websites" websites={newSites.slice(0, 10)} />
        </Col>
      </Row>
    </Container>
  );
};

LaunchStats.propTypes = {
  sitesPerMonth: PropTypes.object.isRequired,
  newSites: PropTypes.array.isRequired,
};

export default clientOnly()(LaunchStats);
